<template>
    <div>
        <!-- Header -->
        <header id="header" class="alt">
            <div id="desktop-header" class="container hide-on-tablet-and-smaller">
                <div class="logo">
                    <a href="/">
                        <img :src="headerData.logoImage" alt="PS Limpeza de Cozinha Industrial e Soluções Térmicas"/>
                    </a> 
                </div>
                <ul class="nav anchor-link">
                    <li v-for="(link, index) in headerData.navLinks" :key="index">
                        <a v-on:click="navLinkTo(link.href, false)">{{link.title}}</a>
                    </li>
                </ul>
            </div>

            <div class="hide-on-desktop">
                <div class="logo">PS Limpeza e Soluções</div>
                <a href="#menu" v-on:click="toggleMobileMenu">Menu</a>
            </div>
        </header>

        <!-- Nav -->
        <nav id="menu" class="mobile-menu">
            <ul class="links anchor-link">
                <li v-for="(link, index) in headerData.navLinks" :key="index">
                    <a v-on:click="navLinkTo(link.href, true)">{{link.title}}</a>
                </li>
            </ul>
            <a href="#menu" class="close" v-on:click="toggleMobileMenu"
                style="-webkit-tap-highlight-color: rgba(0, 0, 0, 0);"></a>
        </nav>
    </div>
</template>

<script>
export default {
    props : {
        headerData : Object
    },
    data() {
        return {
            mobileMenuVisibleClass : 'visible',
        }
    },
    mounted : function() {
        window.addEventListener("scroll", function() {
            var headerEl = document.getElementById("header");
            var headerHeight = headerEl.offsetTop + headerEl.offsetHeight;
            
            if (window.scrollY > headerHeight) {
                if(headerEl.classList.contains("alt")) {
                    headerEl.classList.remove("alt");
                    headerEl.classList.add("reveal");
                }
            }
            else if (!headerEl.classList.contains("alt")) {
                headerEl.classList.remove("reveal");
                headerEl.classList.add("alt");
            }
        });
    },
    methods : {
        navLinkTo : function(refName, isMobileMenu) {
            this.scrollWindowTo(refName);
            
            if(isMobileMenu === true) {
                this.toggleMobileMenu();
            }

            if(refName == "#services-container") {
                this.$parent.setCurrentServiceId(-1);
            }
        },
        scrollWindowTo : function(refName) {
            var element = document.querySelector(refName);
            var topOffset = element.offsetTop;
            window.scrollTo({top: topOffset, behavior: 'smooth'});
        },
        toggleMobileMenu : function() {
            var mobileMenu = this.$el.querySelector(".mobile-menu");
            if(mobileMenu.classList.contains(this.mobileMenuVisibleClass)) {
                mobileMenu.classList.remove(this.mobileMenuVisibleClass)
            }
            else {
                mobileMenu.classList.add(this.mobileMenuVisibleClass)
            }
        },
    }
}
</script>

2
<style scoped>
#header.alt {
	overflow: initial;
}
#header #desktop-header {
	text-align: left;
}
#header #desktop-header .logo {
	position: relative;
}
#header #desktop-header ul.nav {
    float: right;
	font-family: "Poppins", sans-serif;
    font-weight: 300;
}
#header #desktop-header ul.nav > li {
	display: inline;
}
#header #desktop-header ul.nav > li a {
	-webkit-transition: all 0.3s;
    -ms-transition: all 0.3s;
    transition: all 0.3s;
    cursor: pointer;
}
#header #desktop-header ul.nav > li a:hover{
	background-color: transparent;
    color: #fff;
	border-bottom: 1.5px solid #ffffff;
	-webkit-transition: all 0.3s;
    -ms-transition: all 0.3s;
	transition: all 0.3s;
}
</style>